// image-upload-widget.js
import {
  setupDragAndDrop,
  showError,
  checkPrefilledValues,
  getFileExtension
} from './file-widgets-common.js';

let modalInitialized = false;

function initializeModal() {
  if (modalInitialized) return;

  const modalHtml = `
  <div class="modal fade" id="imagePreviewModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Закрыть"></button>
        </div>
        <div class="modal-body p-0">
          <img id="modalPreviewImage" src="" class="w-100" alt="Полноразмерный предпросмотр">
        </div>
      </div>
    </div>
  </div>`;

  $('body').append(modalHtml);
  modalInitialized = true;
}

export function initializeImageWidget(widget) {
  const dropArea         = widget.find('.drop-area');
  const fileInput        = widget.find('input[type="file"]');
  const hiddenInput      = widget.find('input[type="hidden"]');
  const placeholder      = widget.find('.upload-placeholder');
  const previewContainer = widget.find('.preview-container');
  const previewImage     = widget.find('.preview-image');
  const closeBtn         = widget.find('.btn-close-widget');

  // опция полноэкранного просмотра через data-fullview="true"
  const fullviewEnabled = widget.attr('data-fullview') === 'true';

  // let previewBtn = widget.find('.btn-preview-widget');
  // if (!previewBtn.length) {
  //   previewBtn = $(
  //     `<button type="button" class="btn-preview-widget" aria-label="Просмотр">
  //        <i class="fas fa-search-plus"></i>
  //      </button>`
  //   );
  //   widget.find('.preview-container').append(previewBtn);
  // }

  setupDragAndDrop(dropArea, fileInput);

  function validateImageFile(file) {
    const allowed = ['image/png','image/jpeg','image/jpg','image/webp','image/gif'];
    return allowed.includes(file.type);
  }

  /**
   * Отображает превью SVG:
   * 1) читаем текст
   * 2) парсим через DOMParser — при ошибке показываем сообщение
   * 3) при успехе создаём blob-URL и вставляем в <img>
   */
  function showSVGPreview(file) {
    const reader = new FileReader();
    reader.onload = e => {
      const text = e.target.result;
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'image/svg+xml');
      // Если есть ошибка парсинга — показываем ошибку и сбрасываем виджет
      if (doc.getElementsByTagName('parsererror').length) {
        clearImageWidget();
        showError(dropArea, 'Некорректный SVG-файл');
      } else {
        // Корректный SVG — создаём превью + бейдж "SVG"
        const url = URL.createObjectURL(file);
        previewImage.attr('src', url);
        // удаляем старый бейдж, если был
        previewContainer.find('.svg-badge').remove();
        // создаём новый бейдж
        const badge = $('<span>')
          .addClass('svg-badge')
          .text('SVG');
        previewContainer
          .addClass('preview-container')
          .append(badge);
        placeholder.hide();
        previewContainer.show();
        previewContainer.find('.btn-preview-widget').hide();
      }
    };
    reader.onerror = () => {
      clearImageWidget();
      showError(dropArea, 'Ошибка при чтении SVG-файла');
    };
    reader.readAsText(file);
  }

  function showImagePreview(file) {
    const reader = new FileReader();
    reader.onload = e => {
      previewContainer.find('.svg-badge').remove();
      previewContainer.find('.btn-preview-widget').show()
      previewImage.attr('src', e.target.result);
      placeholder.hide();
      previewContainer.show();
    };
    reader.readAsDataURL(file);
  }

  function clearImageWidget() {
    fileInput.val('');
    hiddenInput.val('1');
    previewImage.attr('src','');
    previewContainer.hide();
    placeholder.show();
    dropArea.removeClass('error');
    previewContainer.find('.svg-badge').remove()
  }

  // если включён fullview — генерим кнопку и вешаем обработчик
  if (fullviewEnabled) {
    let previewBtn = widget.find('.btn-preview-widget');
    if (!previewBtn.length) {
      previewBtn = $(
        `<button type="button" class="btn-preview-widget" aria-label="Просмотр">
           <i class="fas fa-search-plus"></i>
         </button>`
      );
      widget.find('.preview-container').append(previewBtn);
    }

    // при клике на кнопку — показываем модалку
    previewBtn.on('click', function(e) {
      e.stopPropagation();       // не даём всплыть до dropArea
      initializeModal();
      const src = previewImage.attr('src');
      $('#modalPreviewImage').attr('src', src);
      const modal = new bootstrap.Modal($('#imagePreviewModal')[0], {
        keyboard: true
      });
      modal.show();
    });
  }
  // previewBtn.on('click', function(e) {
  //   e.stopPropagation();       // не даём всплыть до dropArea
  //   initializeModal();
  //   const src = previewImage.attr('src');
  //   $('#modalPreviewImage').attr('src', src);
  //   const modal = new bootstrap.Modal($('#imagePreviewModal')[0], {
  //       keyboard: true  // позволяет закрыть по Escape
  //   });
  //   modal.show();
  // });

  dropArea.on('click', e => {
    if (!$(e.target).closest('.btn-close-widget').length)
      fileInput.click();
  });

  fileInput.on('change', () => {
    const file = fileInput[0].files[0];
    if (!file) {
      showError(dropArea, 'Файл не найден');
      return;
    }

    const ext = getFileExtension(file.name);
    // SVG-файл: отдельная обработка
    if (file.type === 'image/svg+xml' || ext === 'svg') {
      showSVGPreview(file);
      hiddenInput.val('0');

    // Растровые изображения — как раньше
    } else if (validateImageFile(file)) {
      showImagePreview(file);
      hiddenInput.val('0');

    } else {
      clearImageWidget();
      showError(dropArea, 'Пожалуйста, выберите файл-изображение');
    }
  });

  closeBtn.on('click', e => {
    e.stopPropagation();
    clearImageWidget();
  });

  checkPrefilledValues(widget);
}
